var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden-sm-and-up bg"},[_c('div',{staticClass:"mobile_callme_wrap"},[_c('p',[_vm._v(" Copyright ©2024 亿微电子 . All Rights Reserved ."),_c('br'),_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("闽ICP备2025099456号-1")])])]),_c('div',{staticClass:"navigate_wrap"})])
}]

export { render, staticRenderFns }